import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InvoiceInfoScreen';
import InvoiceInfo from './InvoiceInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getInvoice, getFiles } from 'src/store/actions/invoice-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        invoice: state.invoices.current,
        files: state.invoices.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getInvoice(id)),
        getFiles: (id) => dispatch(getFiles(id)),
    };
}

const InvoiceInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InvoiceInfo);

export default InvoiceInfoScreen;
